<template>
  <component
    v-on="$listeners"
    v-if="haveIcon"
    :is="icon"
    v-bind="$attrs"
  ></component>
</template>

<script>
import printIcon from "./icons/print-icon";
import deleteIcon from "./icons/delete-icon";
import filterIcon from "./icons/filter-icon";
import editIcon from "./icons/edit-icon";
import plusIcon from "./icons/plus-icon";
import cancelIcon from "./icons/cancel-icon";
import sendIcon from "./icons/send-icon";
import eyeIcon from "./icons/eye-icon";
import fileIcon from "./icons/file-icon";
import calculatorIcon from "./icons/calculator-icon";
import shareIcon from "./icons/share-icon";
import infoIcon from "./icons/info-icon";
import checkIcon from "./icons/check-icon";
import contractIcon from "./icons/contract-icon";
import attributeIcon from "./icons/attribute-icon";
import addContract from "./icons/add-contract";
import attrIcon from "./icons/attr-icon";
import documentIcon from "./icons/document-icon";
import disconIcon from "./icons/discon-icon";
import groupIcon from "./icons/group-icon";
import iconGroup from "./icons/icon-group";
import inventIcon from "./icons/inventory-icon";
import requestIcon from "./icons/request-icon";
import spisIcon from "./icons/spis-icon";
import tmtsIcon from "./icons/tmts-icon";
import triangleIcon from "./icons/triangle-icon";
import departmentIcon from "./icons/department-icon";
import categoryIcon from "./icons/category-icon";
import roleIcon from "./icons/role-icon";
import permissionIcon from "./icons/permession-icon";
import userIcon from "./icons/user-icon";
import columnIcon from "./icons/column-icon";
import realizationIcon from "./icons/realization-icon";
import writeOffIcon from "./icons/write-off-icon";
import indexIcon from "./icons/index-icon";
import measureIcon from "./icons/measure-icon";
import applyIcon from "./icons/apply-icon";
import rejectIcon from "./icons/reject-icon";
import dashboardIcon from "./icons/dashboard-icon";
import bellIcon from "./icons/bell-icon";
import finishIcon from "@/plugins/VueIcon/icons/finish-icon.vue";
import cogIcon from "@/plugins/VueIcon/icons/cog-icon.vue";
/// my new icons
import warehouseIcon from "./icons/warehouse-icon.vue";
import reportIconVue from "./icons/report-icon.vue";
import history from "./icons/history.vue";
import movingIcon from "./icons/moving-icon.vue";
import inventarization from "./icons/invertization.vue";
import tmcIcon from "./icons/tmc-icon.vue";
import warehouseNameIcon from "@/plugins/VueIcon/icons/WarehouseNameIcon.vue";
// new-btn-icons
import newEyeIcon from "@/plugins/VueIcon/icons/newEyeIcon.vue";
import newPencilIcon from "@/plugins/VueIcon/icons/newPencilIcon.vue";
import newTrashIcon from "@/plugins/VueIcon/icons/newTrashIcon.vue";
import newUserIcon from "@/plugins/VueIcon/icons/newUserIcon.vue";
import newPlusIcon from "@/plugins/VueIcon/icons/newPlusIcon.vue";
import newPrintIcon from "@/plugins/VueIcon/icons/newPrintIcon.vue";
import newTimeIcon from "@/plugins/VueIcon/icons/newTimeIcon.vue";
import newWarehouseIcon from "@/plugins/VueIcon/icons/newWarehouseIcon.vue";
import newFileEdit from "@/plugins/VueIcon/icons/newFileEdit.vue";
import newCogIcon from "@/plugins/VueIcon/icons/newCogIcon.vue";
import newRightArrow from "@/plugins/VueIcon/icons/newRightArrow.vue";
import newShareIcon from "@/plugins/VueIcon/icons/newShareIcon.vue";
import newTaskListIcon from "@/plugins/VueIcon/icons/newTaskListIcon.vue";
import newCheckIcon from "@/plugins/VueIcon/icons/newCheckIcon.vue";
import newCancelIcon from "@/plugins/VueIcon/icons/newCancelIcon.vue";
import newLoaderIcon from "@/plugins/VueIcon/icons/newLoaderIcon.vue";
import newBuisnessChart from "@/plugins/VueIcon/icons/newBuisnessChart.vue";
import newFileDownloadIcon from "@/plugins/VueIcon/icons/newFileDownloadIcon.vue";
import newRequestIcon from "@/plugins/VueIcon/icons/newRequestIcon.vue";
import newFileUpdloadIcon from "@/plugins/VueIcon/icons/newFileUpdloadIcon.vue";
import newTextBoxPlus from "@/plugins/VueIcon/icons/newTextBoxPlus.vue";
import newRefreshIcon from "@/plugins/VueIcon/icons/newRefreshIcon.vue";
import newBoldCloseIcon from "@/plugins/VueIcon/icons/newBoldCloseIcon.vue";
import newCalcIcon from "@/plugins/VueIcon/icons/newCalcIcon.vue";
import newFlagIcon from "@/plugins/VueIcon/icons/newFlagIcon.vue";
import newPermissionIcon from "@/plugins/VueIcon/icons/newPermissionIcon.vue";

// Settings Icons

import settingsGroupIcon from "@/plugins/VueIcon/icons/settingsGroupIcon.vue";
import settingsProductIcon from "@/plugins/VueIcon/icons/settingsProductIcon.vue";
import settingsAttributeIcon from "@/plugins/VueIcon/icons/settingsAttributeIcon.vue";
import settingsDepartmentIcon from "@/plugins/VueIcon/icons/settingsDepartmentIcon.vue";
import settingsCategoryIcon from "@/plugins/VueIcon/icons/settingsCategoryIcon.vue";
import settingSupplierIcon from "@/plugins/VueIcon/icons/settingSupplierIcon.vue";
import settingRoleIcon from "@/plugins/VueIcon/icons/settingRoleIcon.vue";
import settingsMeasureIcon from "@/plugins/VueIcon/icons/settingsMeasureIcon.vue";
import settingsCustomerIcon from "@/plugins/VueIcon/icons/settingsCustomerIcon.vue";
import warehouseTypeIcon from "@/plugins/VueIcon/icons/warehouseTypeIcon.vue";
import geolacationIcon from "@/plugins/VueIcon/icons/geolacationIcon.vue";
import closeEyeIcon from "@/plugins/VueIcon/icons/closeEyeIcon.vue";
import warehouseAccessUserIcon from "@/plugins/VueIcon/icons/warehouseAccessUserIcon.vue";
import mapIcon from "@/plugins/VueIcon/icons/mapIcon.vue";
import zoneTypeIcon from "@/plugins/VueIcon/icons/zoneTypeIcon.vue";
import stellageCountIcon from "@/plugins/VueIcon/icons/StellageCountIcon.vue";
import newWarehouseTypeIcon from "@/plugins/VueIcon/icons/newWarehouseTypeIcon.vue";
import blackWarehouseIcon from "@/plugins/VueIcon/icons/blackWarehouseIcon.vue";

import myOffice from "./icons/my-office.vue";
import FolderIcon from "./icons/folder.vue";
import deletePhoto from "./icons/deletePhoto.vue";
import verifyIcon from "./icons/verify-icon.vue";
import warningIcon from "./icons/warning-icon.vue";
import qrcodeIcon from "./icons/qrcode-icon.vue";

export default {
  name: "VueIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  components: {
    qrcodeIcon,
    warningIcon,
    verifyIcon,
    blackWarehouseIcon,
    newWarehouseTypeIcon,
    stellageCountIcon,
    zoneTypeIcon,
    mapIcon,
    warehouseAccessUserIcon,
    closeEyeIcon,
    geolacationIcon,
    warehouseTypeIcon,
    warehouseNameIcon,
    settingsCustomerIcon,
    settingsMeasureIcon,
    settingRoleIcon,
    settingSupplierIcon,
    settingsCategoryIcon,
    settingsDepartmentIcon,
    settingsAttributeIcon,
    settingsProductIcon,
    settingsGroupIcon,
    newPermissionIcon,
    newFlagIcon,
    newCalcIcon,
    newBoldCloseIcon,
    newRefreshIcon,
    newTextBoxPlus,
    newFileUpdloadIcon,
    newRequestIcon,
    newFileDownloadIcon,
    newBuisnessChart,
    newLoaderIcon,
    newCancelIcon,
    newCheckIcon,
    newTaskListIcon,
    newShareIcon,
    newRightArrow,
    newCogIcon,
    newFileEdit,
    newWarehouseIcon,
    newTimeIcon,
    newPrintIcon,
    newPlusIcon,
    newTrashIcon,
    newUserIcon,
    newPencilIcon,
    newEyeIcon,
    cogIcon,
    finishIcon,
    dashboardIcon,
    deleteIcon,
    editIcon,
    plusIcon,
    cancelIcon,
    sendIcon,
    eyeIcon,
    fileIcon,
    calculatorIcon,
    shareIcon,
    infoIcon,
    checkIcon,
    contractIcon,
    attributeIcon,
    addContract,
    attrIcon,
    documentIcon,
    disconIcon,
    groupIcon,
    iconGroup,
    inventIcon,
    requestIcon,
    spisIcon,
    tmtsIcon,
    triangleIcon,
    departmentIcon,
    categoryIcon,
    roleIcon,
    permissionIcon,
    userIcon,
    columnIcon,
    realizationIcon,
    writeOffIcon,
    filterIcon,
    printIcon,
    indexIcon,
    measureIcon,
    applyIcon,
    rejectIcon,
    bellIcon,
    warehouseIcon,
    reportIconVue,
    history,
    movingIcon,
    inventarization,
    tmcIcon,
    myOffice,
    FolderIcon,
    deletePhoto,
  },
  computed: {
    haveIcon() {
      return Object.keys(this.$options.components).some((item) => {
        return item === this.icon;
      });
    },
  },
  created() {
    if (!this.haveIcon) {
      console.warn(`We have not ${this.icon} icon. Please save it`);
    }
  },
};
</script>
